import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

export const calcV100MethodB = (
    airFlowString: string,
    temperatureDiffAirString: string,
    temperatureDiffWaterString: string,
    specificHeatCapacity: string,
    density: string,
) => {
    try {
        const qAir = new Decimal(airFlowString).mul(new Decimal(temperatureDiffAirString)).mul(1.08);
        return qAir
            .dividedBy(
                new Decimal(temperatureDiffWaterString)
                    .mul(8.01)
                    .mul(new Decimal(density))
                    .mul(new Decimal(specificHeatCapacity)),
            )
            .toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};
